import styled from 'styled-components';

export const Button = styled.div`
    min-width : 100px;
    background : ${props => props.background ? props.background : "#8fc649"};
    color : #fff;
    width : ${props => props.width ? props.width : "100%"};
    margin-bottom : ${props => props.marginBottom ? props.marginBottom : "12px"};
    display : flex;
    align-items : center;
    justify-content :center;
    padding : ${props => props.padding ? props.padding : "0"};
    border-radius : ${props => props.borderRadius ? props.borderRadius : "0"};
    font-size: ${props => props.fontSize ? props.fontSize : "16px"};
    box-sizing : border-box;
    cursor: pointer;
    transition : .3s ease;
    position : relative;
    top : ${props => props.top ? props.top : "unset"} !important;
    >img{
        position : absolute;
        width : ${props => props.imgWidth ? props.imgWidth : "30px"};
        right : 5px;
        transition : .2s ease;
    }
    &:hover{
        opacity : .9;
        img{
            right : 0px;
        }
    }
`

export const ButtonL = styled.div`
    min-width : 100px;
    background : ${props => props.background ? props.background : "#8fc649"};
    color : #fff;
    width : ${props => props.width ? props.width : "100%"};
    margin-bottom : ${props => props.marginBottom ? props.marginBottom : "12px"};
    display : flex;
    align-items : center;
    justify-content :center;
    padding : ${props => props.padding ? props.padding : "0"};
    border-radius : ${props => props.borderRadius ? props.borderRadius : "0"};
    font-size: ${props => props.fontSize ? props.fontSize : "16px"};
    box-sizing : border-box;
    cursor: pointer;
    transition : .3s ease;
    position : relative;
    top : ${props => props.top ? props.top : "unset"} !important;
    >img{
        position : absolute;
        width : ${props => props.imgWidth ? props.imgWidth : "30px"};
        left : 5px;
        transition : .2s ease;
    }
    &:hover{
        opacity : .9;
        img{
            left : 0px;
        }
    }
`

export const ErrorText = styled.p`
    color : #ef2c35;
    font-size : 12px;
    text-align : left;
    margin : ${props => props.margin ? props.margin : " 0 0 10px 0"};
    position : ${props => props.absolute ? props.absolute : "relative"};
    top : ${props =>props.top ? props.top : "0px"};
    width : 100%;
    text-align : ${props => props.textAlign ? props.textAlign  : "left"};
`